module.exports = __webpack_public_path__ + "static/media/ic_sound_mute.c995dd7c.svg";